<template>
  <a-modal
    :visible="visible"
    :destroyOnClose="true"
    :centered="true"
    @ok="handleOk"
    @cancel="handleCancel"
    width="600px"
    :title="$t('emails.select')"
    :okText="$t('send')"
    :confirm-loading="confirmLoading"
  >
    <a-table
      size="small"
      :columns="columns"
      :data-source="data"
      :row-selection="{ selectedRowKeys: pageSelectedRows, onChange: onSelectChange }"
      :pagination="{ onChange: onPaginationChange }"
    >
      <div slot="email"></div>
      <div slot="name"></div>
    </a-table>
  </a-modal>
</template>

<script>
export default {
  props: ['visible', 'data', 'confirmLoading'],
  data() {
    return {
      selectedRowKeys: {},
      page: 1,
    };
  },
  computed: {
    columns() {
      return [
        {
          title: 'Email',
          dataIndex: 'email',
        },
        {
          title: 'Name',
          dataIndex: 'name',
        },
      ];
    },
    pageSelectedRows() {
      return this.selectedRowKeys[this.page] || [];
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.$set(this.selectedRowKeys, this.page, selectedRowKeys);
      this.$emit('select', selectedRowKeys);
    },
    onPaginationChange(selectedPage) {
      this.page = selectedPage;
    },
    handleCancel() {
      this.selectedRowKeys = {};
      this.$emit('cancel');
    },
    handleOk() {
      const selected = Object.entries(this.selectedRowKeys)
        .reduce(
          (results, [row, keys]) =>
            results.concat(keys.map((key) => Number(`${row - 1}${key}`))),
          [],
        )
        .map((index) => this.data[index]);
      this.selectedRowKeys = {};
      this.$emit('confirm', selected);
    },
  },
};
</script>